import {type FC, useEffect} from 'react';

import type {Props} from './types';

import {Lightbox} from '../../components/Lightbox';
import {useController} from './controller';
import {lightbox} from './lightboxApi';

export const LightboxContainer: FC<Props> = ({getMountPoint}) => {
  const {hide, isOpen, show, showParams} = useController();

  useEffect(() => {
    lightbox.show = show;
    lightbox.hide = hide;
  }, [hide, show]);

  return (
    <Lightbox
      getMountPoint={getMountPoint}
      isOpen={isOpen}
      onClose={hide}
      {...showParams}
    />
  );
};
